import { Nullable } from "."

export type PolicyholderType = "NotSet" | "Individual" | "Business"

export interface IPolicyholderPersonName {
  firstName: Nullable<string>
  lastName: Nullable<string>
  title: Nullable<string>
}

export interface IPolicyholderPerson {
  dateOfBirth: Nullable<string>
  emailAddress: Nullable<string>
  name: IPolicyholderPersonName
  phoneNumber: Nullable<string>
}

export interface IUniversalAddressCountry {
  referenceID: Nullable<string>
  text: Nullable<string>
}

export interface IUniversalAddress {
  line1: Nullable<string>
  line2?: Nullable<string>
  line3?: Nullable<string>
  locality: Nullable<string>
  postalCode: Nullable<string>
  province?: Nullable<string>
  provinceReferenceID?: Nullable<string>
  uniqueReference?: Nullable<string>
  country?: IUniversalAddressCountry
}

export interface IPolicyholder {
  businessName: string
  contact: IPolicyholderPerson
  contactAddress: IUniversalAddress
  dateCreated: string
  id: string
  legalName: Nullable<string>
  policyholderType: PolicyholderType
  referenceID: Nullable<string>
  ownerID: Nullable<string>
  companyID: Nullable<string>
  policyholderID?: string
}

export interface IPolicyholderSearchResult {
  policyholderID: string
  referenceID: Nullable<string>
  legalName: Nullable<string>
  policyholderType: PolicyholderType
  businessName: Nullable<string>
  contact: IPolicyholderPerson
  contactAddress: IUniversalAddress
  companyID: Nullable<string>
  ownerID: Nullable<string>
}

export function policyholderSearchResultToPolicyholder(
  result: IPolicyholderSearchResult
): IPolicyholder {
  const { policyholderID, ...rest } = result
  return {
    ...rest,
    id: policyholderID,
    businessName: result.businessName ?? "",
    dateCreated: ""
  }
}
